import { useEffect, useRef, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { getStore } from '../ApplicationState';
import { isCoTeacherAdminUIEnabled } from '../BackendInterface';
import { canAccessAdministrator } from './access';
import { getVisibleAdminCards } from './adminCards';
import styles from './AdministratorPage.module.scss';

const AdministratorPage = () => {
  const userProfile = getStore().getState().user.userProfile;
  const [workspaceHeight, setWorkspaceHeight] = useState<number>(520);
  const workspaceRef = useRef<HTMLDivElement | null>(null);
  const [visibleCards, setVisibleCards] = useState(getVisibleAdminCards(false));

  useEffect(() => {
    const updateWorkspaceHeight = () => {
      if (!workspaceRef.current) {
        return;
      }

      const top = workspaceRef.current.getBoundingClientRect().top;
      const viewportHeight = window.innerHeight;
      const computed = Math.floor(viewportHeight - top - 8);
      setWorkspaceHeight(Math.max(280, computed));
    };

    updateWorkspaceHeight();
    window.addEventListener('resize', updateWorkspaceHeight);

    return () => {
      window.removeEventListener('resize', updateWorkspaceHeight);
    };
  }, []);

  useEffect(() => {
    const districtId = userProfile?.district || '';
    const schoolId = userProfile?.schoolId || '';

    isCoTeacherAdminUIEnabled(districtId, schoolId).then((enabled) => {
      setVisibleCards(getVisibleAdminCards(enabled));
    });
  }, [userProfile?.district, userProfile?.schoolId]);

  if (!userProfile) {
    return null;
  }

  if (!canAccessAdministrator(userProfile?.licenseLevel)) {
    return <Redirect to='/unauthorized' />;
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Administrator</h1>
      <div
        ref={workspaceRef}
        className={styles.workspace}
        style={{ height: `${workspaceHeight}px`, maxHeight: `${workspaceHeight}px` }}
      >
        <div className={styles.grid}>
          {visibleCards.map((card) => (
            <Link key={card.route} to={card.route} className={styles.card}>
              <h2>{card.title}</h2>
              <p>{card.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdministratorPage;
